<template>
  <Header class="mb-8" :level="4">
    <v-icon class="pr-4" :size="50" color="textColor">{{ newPostIcon }}</v-icon>
    Neue Antwort
  </Header>
</template>

<script lang="ts">
import { defineComponent } from "vue"
import Header from "components/UI/Header.vue"
import { mdiCommentPlusOutline } from "@mdi/js"

export default defineComponent({
  name: "PostFormHeader",
  components: { Header },
  setup() {
    return {
      newPostIcon: mdiCommentPlusOutline,
    }
  },
})
</script>
